import React from 'react'

function HelpShape() {
  return (
    <section className="help-shape-the" id="help-shape-the">
        <div className="row ">
            <div className="container">
                <div className="help-shape-the">
                    <div className="top-images wow fadeInLeft mobile-hide">
                        <img src="./images/firstFifty-images/help-shape-img.png"
                            alt="Just Send Your Updates—we’ll Handle The Rest" />
                    </div>

                    <div className="top-content wow fadeInRight">
                        <div className="title">
                            <h2 className="white">Help Shape the 
                                <span className="red">Future of Snapshot Videos</span>
                            </h2>
                            {/* <h2 className="white">Help Shape the <span className="red">Future of Association
                                    Communications</span></h2> */}
                        </div>
                        <div className="top-images wow fadeInLeft mobile-show">
                            <img src="./images/firstFifty-images/help-shape-img.png"
                                alt="Just Send Your Updates—we’ll Handle The Rest" />
                        </div>
                        <p>Join our <b>First 50</b> and become part of an exclusive group of early adopters.
                            Your feedback will directly shape new features and enhancements.</p>
                        <p>You’ll get behind-the-scenes access, early previews, and the chance to help us build
                            something that works even better for associations like yours.</p>
                        <a href="#reserve-your-spot" className="btn white order-btn">Order Now</a>
                    </div>
                </div>
            </div>
        </div>
    </section>
  )
}

export default HelpShape